import React from "react";
import { AnalyticsTrigger, Modal, ModalContent, ModalFooter } from "telia-front-react";
const InformationModalBase = (props) => {
  const { isModalOpen, analyticsId, modalContent, modalFooter, modalCloseCallback } = props;
  return /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Modal - ".concat(analyticsId), callback: "onClose" } }, /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: isModalOpen,
      "aria-labelledby": "information-check-heading",
      initialFocusedElementId: "change-data",
      cover: {
        backgroundColor: "#999999",
        minHeight: 500,
        image: {
          srcset: "https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto,w_480/crm-components/Telia_Company_112_3.jpg 480w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto,w_800/crm-components/Telia_Company_112_3.jpg 800w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto,w_1024/crm-components/Telia_Company_112_3.jpg 1024w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto,w_1280/crm-components/Telia_Company_112_3.jpg 1280w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto,w_1920/crm-components/Telia_Company_112_3.jpg 1920w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto,w_2300/crm-components/Telia_Company_112_3.jpg 2300w",
          role: "presentation"
        },
        fillImage: true
      },
      hasContentComponent: true,
      onClose: () => modalCloseCallback()
    },
    /* @__PURE__ */ React.createElement(ModalContent, null, modalContent),
    /* @__PURE__ */ React.createElement(ModalFooter, null, modalFooter)
  ));
};
export {
  InformationModalBase as default
};
